// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsTopographyCalculation_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M32 0H0V32H17.8591L15.8591 30H9.70399C10.3297 28.1712 11.8575 26.452 14 25.0773V22.7884C10.6947 24.6342 8.37163 27.2162 7.63932 30H2V16.3696C5.70398 18.5091 11.4979 18.7013 17.2257 16.4838C24.9247 13.503 29.7802 7.22278 28.6776 2H30V15.8552L32 17.8552V0ZM16.5036 14.6187C10.7257 16.8557 4.94214 16.4744 2 13.9821V8.15949C3.80375 9.22044 6.27455 9.87463 9 9.87463C14.5228 9.87463 19 7.18834 19 3.87463C19 3.21998 18.8253 2.58981 18.5022 2H26.6158C27.9384 6.33105 23.5167 11.9035 16.5036 14.6187ZM2 2H16.0688C16.6632 2.55917 17 3.19724 17 3.87463C17 6.08377 13.4183 7.87463 9 7.87463C5.98797 7.87463 3.36473 7.04235 2 5.81264V2Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5 16H23.5L22.6833 17.6334C21.8652 17.8017 21.1033 18.1237 20.429 18.5679L18.6955 17.9901L17.9884 18.6972L18.5664 20.4313C18.123 21.1051 17.8015 21.8662 17.6334 22.6833L16 23.5V24.5L17.6334 25.3167C17.8019 26.1356 18.1244 26.8982 18.5692 27.573L17.992 29.3045L18.6991 30.0116L20.432 29.434C21.1056 29.8772 21.8664 30.1985 22.6833 30.3666L23.5 32H24.5L25.3167 30.3666C26.1348 30.1983 26.8967 29.8763 27.571 29.4321L29.3045 30.0099L30.0116 29.3028L29.4336 27.5687C29.877 26.8949 30.1985 26.1338 30.3666 25.3167L32 24.5V23.5L30.3666 22.6833C30.1984 21.866 29.8769 21.1048 29.4334 20.431L30.0119 18.6955L29.3048 17.9884L27.5693 18.5668C26.8954 18.1232 26.1341 17.8016 25.3167 17.6334L24.5 16ZM28.4994 24.0002C28.4994 26.4855 26.4847 28.5002 23.9994 28.5002C21.5141 28.5002 19.4994 26.4855 19.4994 24.0002C19.4994 21.5149 21.5141 19.5002 23.9994 19.5002C26.4847 19.5002 28.4994 21.5149 28.4994 24.0002Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsTopographyCalculation is a generated icon component.
 */
let IconRmsTopographyCalculation = IconRmsTopographyCalculation_1 = class IconRmsTopographyCalculation extends IconBaseElement {
    render() {
        return html `${IconRmsTopographyCalculation_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsTopographyCalculation.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsTopographyCalculation = IconRmsTopographyCalculation_1 = __decorate([
    customElement('zui-icon-rms-topography-calculation')
], IconRmsTopographyCalculation);
export { IconRmsTopographyCalculation };
